import { GetTermManualInput, GetTermManualOutput } from '@amzn/coral_com-amazon-carrierlogisticswebserver-model';
import { Observable } from 'rxjs';
import CarrierLogisticsWebServerClient from '../clients/CarrierLogisticsWebServerClient';

interface DownloadTermManualInput {
  termKey: string;
}

export function getTermManualService({
  termKey
}: DownloadTermManualInput
): Observable<GetTermManualOutput> {
  return CarrierLogisticsWebServerClient.getTermManual(GetTermManualInput.clone({
    presignedUrlInputParameters:{
      s3ObjectKeys: [termKey]
    }
  }));
}

export default getTermManualService;